module.exports = __webpack_public_path__ + "static/media/engagement-video.db2b3fe9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/engagement-video.svg
// module id = 437
// module chunks = 0